/**
 * File processing utilities
 */

export function processFileData(rawData) {
    return rawData.map(file => ({
        id: file.id,
        name: file.name || file.filename,
        path: file.path,
        size: file.size,
        format: extractFormat(file.name || file.filename),
        category: file.category,
        subcategory: file.subcategory,
        lastModified: file.lastModified || file.modified_date,
        icon: getFileIcon(file.format || extractFormat(file.name))
    }));
}

// Extract file format from filename
export function extractFormat(filename) {
    if (!filename) return 'unknown';
    const parts = filename.split('.');
    return parts.length > 1 ? parts.pop().toLowerCase() : 'unknown';
}

// Get icon for file format
export function getFileIcon(format) {
    const iconMap = {
        pdf: '📄',
        doc: '📝',
        docx: '📝',
        mp3: '🎵',
        mp4: '🎥',
        jpg: '🖼️',
        jpeg: '🖼️',
        png: '🖼️',
        zip: '📦',
        txt: '📃',
        default: '📎'
    };

    return iconMap[format] || iconMap.default;
}

// Get file item template
export function getFileItemTemplate() {
    return `
        <div class="file-item" data-file-id="{id}">
            <div class="file-icon">{icon}</div>
            <div class="file-info">
                <div class="file-name">{name}</div>
                <div class="file-meta">
                    <span class="file-size">{size}</span>
                    <span class="file-date">{date}</span>
                </div>
            </div>
            <div class="file-actions">
                <button class="download-btn" data-file-id="{id}">Скачать</button>
            </div>
        </div>
    `;
}

// Get filter DOM elements
export function getFilterElements() {
    return {
        filtersContainer: document.getElementById('filters-div'),
        filtersWrapper: document.querySelector('.filters'),
        dateContainer: document.querySelector('.filter-date-container'),
        dateFromInput: document.querySelector('.filter-date-from'),
        dateToInput: document.querySelector('.filter-date-to'),
        clearButton: document.querySelector('.filters-clear'),
        searchInput: document.getElementById('fnd_searchbox')
    };
}

